
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 35 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M26.364 27.99c4.436.878 7.363 2.387 7.363 4.1 0 2.712-7.326 4.91-16.363 4.91C8.326 37 1 34.802 1 32.09c0-1.707 2.906-3.21 7.315-4.09"}}),_c('path',{attrs:{"d":"M20.636 32.09h-6.545l-.818-8.18L10 23.09v-6.545a3.273 3.273 0 013.273-3.272h8.182a3.273 3.273 0 013.272 3.272v6.546l-3.272.818-.819 8.182zM17.364 9.182h0a4.091 4.091 0 01-4.091-4.091h0A4.091 4.091 0 0117.363 1h0a4.091 4.091 0 014.092 4.09h0a4.091 4.091 0 01-4.091 4.092z"}})])])
          )
        }
      }
    